const { create, all } = require('mathjs')
const config = {
    number: 'BigNumber',
    precision: 20
}
const math = create(all, config)

export default {
    add(a, b) {
        return math.add(math.bignumber(a), math.bignumber(b));
    },
    subtract(a, b) {
        return math.subtract(math.bignumber(a), math.bignumber(b));
    },
    multiply(a, b) {
        return math.multiply(math.bignumber(a), math.bignumber(b));
    },
    divide(a, b) {
        return math.divide(math.bignumber(a), math.bignumber(b));
    },
    chain(a) {
        return math.chain(a)
    },
    toFixed(a) {
        return parseFloat(a.toFixed(2));
    },
    show(a) {
        return a.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
}